document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".custom-play-button").forEach(function (button) {
    button.addEventListener("click", function () {
      var videoId = button.getAttribute("data-id");
      var video = document.getElementById(videoId);
      var poster = document.querySelector(
        '.video-poster[data-id="' + videoId + '"]'
      );

      if (video.paused) {
        video.play();
        button.classList.add("hidden");
        if (poster) {
          poster.style.display = "none"; // Hide poster image when video plays
        }
      }
    });
  });
});
